export default __webpack_public_path__ + "static/media/trainer_1.c49baf81.PNG";